// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.customFileSize-width {\n  width: 470px; /* 或者任何你想要的宽度 */\n}\n", ""]);
// Exports
module.exports = exports;
